import React from "react";
import { Checkbox, Tooltip } from "@material-ui/core";
import clsx from "clsx";
import FormFieldBox from "../DesignSystem/formFieldBox";
import DropdownAuto from "../DesignSystem/dropdown_autocomplete";
import Textarea from "../DesignSystem/textarea";
import InfoIcon from "../../assets/images/info-icon.svg";
import CheckboxIcon from "../../assets/images/checkbox-unchecked.svg";
import CheckboxCheckedIcon from "../../assets/images/checkbox-checked.svg";
import WaveXchangeIcon from "../../assets/images/wavexchange-small-icon.svg";
import { useGroup } from "../ManagePorts/GroupOperations/useGroup";

interface NetworkElementUpperSectionProps {
  type: "ne" | "fe";
  networkElementOptions: any[];
  selectedNetworkElement: any;
  portDescription: string;
  verifyPorts: boolean;
  onNetworkElementChange: (value: any) => void;
  onPortDescriptionChange: (_: any) => void;
  onKeypress: (_: any) => void;
  handleVerifyChange: () => void;
  inputValue: string;
  onInputChange: (_: string) => void;
  link?: boolean;
  useGroupProps?: ReturnType<typeof useGroup>;
}

const NetworkElementUpperSection: React.FC<NetworkElementUpperSectionProps> = ({
  link,
  inputValue,
  onInputChange,
  verifyPorts,
  type,
  networkElementOptions,
  selectedNetworkElement,
  portDescription,
  handleVerifyChange,
  onNetworkElementChange,
  onPortDescriptionChange,
  onKeypress,
  useGroupProps,
}) => {
  const organizationId = parseInt((localStorage.getItem("org_id") && localStorage.getItem("org_id")) || "0");

  return (
    <div className={clsx(link && "link", "upper-section-root")}>
      <div>
        <FormFieldBox excludeMarginTop>
          <label>
            Select {type === "fe" ? "Far End" : "Near End"}
            <span className="asterisk">*</span>
          </label>
          <DropdownAuto
            className="bandwidth"
            inputValue={inputValue}
            onInputChange={onInputChange}
            value={selectedNetworkElement.ne_name || ""}
            onNetNames={networkElementOptions.filter((item: any) => item.on_net).map((item: any) => item.ne_name)}
            options={networkElementOptions.map((item: any) => item.ne_name)}
            onChange={onNetworkElementChange}
          />
        </FormFieldBox>
      </div>
      <div>
        <FormFieldBox excludeMarginTop>
          <div className="text-area-root">
            <div>
              <label>
                Group
                <span className="asterisk">*</span>
              </label>
              <Tooltip
                classes={{
                  tooltip: "tooltip",
                }}
                title="Select a group which applies to all of the ports being added."
                arrow
                placement="top"
              >
                <img src={InfoIcon} alt="Info" />
              </Tooltip>
            </div>
            <div>{useGroupProps?.GroupDropdownProps.dropdownComponent || ''}</div>
          </div>
        </FormFieldBox>
        <div style={{ height: "50px" }}>
          {selectedNetworkElement.on_net && selectedNetworkElement.leased_organization !== organizationId ? (
            <FormFieldBox excludeMarginTop excludeMarginBottom>
              <div className="verify-checkbox">
                <div>
                  <Checkbox
                    classes={{
                      root: "selection-checkbox",
                    }}
                    color="default"
                    checked={verifyPorts}
                    onChange={handleVerifyChange}
                    icon={<img src={CheckboxIcon} alt="Checkbox" className="checkbox-icon" />}
                    checkedIcon={<img src={CheckboxCheckedIcon} alt="Checkbox Checked" className="checkbox-checked-icon" />}
                    inputProps={{
                      // @ts-ignore
                      "data-testid": "checkbox-input",
                    }}
                    data-testid="checkbox"
                  />
                  <label>Move to WaveXChange</label>
                </div>
                <div>
                  <Tooltip
                    classes={{
                      tooltip: "tooltip",
                    }}
                    title="The selected location is manageable in real-time by WaveXchange Software. Click the checkbox to the left to request for your ports to be verified."
                    arrow
                    placement="right"
                  >
                    <img src={WaveXchangeIcon} alt="Info" />
                  </Tooltip>
                </div>
              </div>
            </FormFieldBox>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default NetworkElementUpperSection;
